// Loads the Meta Pixel script (fbevents.js) on demand, only after the user
// has granted advertising consent. Idempotent: subsequent calls are no-ops.
// The window.fbq stub is created in public/index.html so any pre-consent
// track() call is safely swallowed (the queue is intentionally never flushed
// because pre-consent events must never reach Meta).

const PIXEL_ID = "1129972809096366";
let loaded = false;

export function loadFbPixel() {
  if (loaded) return;
  if (typeof window === "undefined" || typeof document === "undefined") return;
  loaded = true;

  // Reset the pre-consent queue so nothing gathered before consent leaks out.
  if (typeof window.fbq === "function") {
    try {
      window.fbq.queue = [];
    } catch (_) {
      /* ignore */
    }
  }

  // Inject the official Pixel script.
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://connect.facebook.net/en_US/fbevents.js";
  const first = document.getElementsByTagName("script")[0];
  if (first && first.parentNode) {
    first.parentNode.insertBefore(s, first);
  } else {
    document.head.appendChild(s);
  }

  // Initialise the pixel. Any track() calls made AFTER this line reach Meta.
  try {
    window.fbq("init", PIXEL_ID);
  } catch (_) {
    /* ignore */
  }
}

/** True once the fbevents.js script has been requested in this session. */
export function isPixelLoaded() {
  return loaded;
}
